(() => {
  const ADD_TO_CART_LABEL = 'カートに入れる';
  const LEGACY_LABEL = '公式ストアで購入';

  function normalizeAddToCartLabel() {
    const button = document.querySelector('#MainContent product-form button[name="add"]');
    const label = button && button.querySelector('span');
    if (!button || !label) return;

    const current = label.textContent.replace(/\s+/g, ' ').trim();
    if (button.disabled) {
      if (current === LEGACY_LABEL) {
        label.textContent = (window.variantStrings && window.variantStrings.soldOut) || '売り切れ';
      }
      return;
    }

    if (current === LEGACY_LABEL) {
      label.textContent = ADD_TO_CART_LABEL;
    }
  }

  function placeMarketplace() {
    const slot = document.querySelector('[data-aug-marketplace-slot]');
    const section = document.querySelector('[data-aug-marketplace-section]');
    const marketplace = document.querySelector('#MainContent .aug-marketplace');
    if (!slot || !section || !marketplace) return;

    const reviews = document.querySelector('#MainContent .aug-marketplace__reviews');
    const amazon = marketplace.querySelector('.aug-marketplace__amazon');
    if (!amazon) return;

    let otherHeading = marketplace.querySelector('.aug-marketplace__other-heading');
    if (!otherHeading) {
      otherHeading = document.createElement('p');
      otherHeading.className = 'aug-marketplace__other-heading';
      otherHeading.textContent = '他の購入方法';
    }

    if (reviews) marketplace.appendChild(reviews);
    marketplace.appendChild(otherHeading);
    marketplace.appendChild(amazon);
    marketplace.classList.add('aug-marketplace--secondary');
    slot.appendChild(marketplace);

    const title = section.querySelector('[data-aug-marketplace-title]');
    if (title) title.textContent = reviews ? 'レビューと他の購入方法' : '他の購入方法';
    section.hidden = false;
  }

  function init() {
    normalizeAddToCartLabel();
    placeMarketplace();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.setTimeout(init, 320);
  window.setTimeout(init, 900);
  document.addEventListener('shopify:section:load', init);

  const productInfo = document.querySelector('#MainContent .product__info-container');
  if (productInfo && window.MutationObserver) {
    const observer = new MutationObserver(normalizeAddToCartLabel);
    observer.observe(productInfo, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }
})();
